import {useEffect, useState} from 'react';
import Banner from './components/Banner';
import Beneficios from './components/Beneficios';
import Footer from './components/Footer';
import Galeria from './components/Galeria';
import Navbar from './components/Navbar';
import Nosotros from './components/Nosotros';
import Productos from './components/Productos';
import Menu from './components/extras/Menu';
import Mapa from './components/Mapa';

function App() {
	const [scroll, setScroll] = useState(false);
	const [mostrarmenu, setMostrarMenu] = useState(false);

	useEffect(() => {
		window.onscroll = () => {
			if (window.pageYOffset > 0) {
				setScroll(true);
			} else {
				setScroll(false);
			}
		};
	}, []);

	return (
		<div className='App'>
			<Navbar scroll={scroll} mostrarmenu={mostrarmenu} setMostrarMenu={setMostrarMenu} />
			<Banner />
			<Menu mostrarmenu={mostrarmenu} />
			<Nosotros />
			<Beneficios />
			<Galeria />
			<Productos />
			<Mapa />
			<Footer />
		</div>
	);
}

export default App;
